import { supabase } from './api'

export const revalidate = 0

function getCompanyId() {
  return localStorage.getItem("companyId");
}


export async function getAllData() {
  const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentinfoclassdetail').select().eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }


  export async function getDataWithType(type) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentinfoclassdetail').select().eq('type',type).eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataWithoutClass() {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentinfoclassdetail').select().is('studentId',null).eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function getDataWithClassId(classId) {
    const companyId = getCompanyId();
    const { data, error } = await supabase.from('studentinfoclassdetail').select().eq('classId',classId).eq('companyId',companyId);

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
  
  export async function getIdData(id) {
    const { data, error } = await supabase.from('studentinfoclassdetail').select()
    .eq('id', id);
    //.eq("isActive", true);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function addData(adata) {
    const { data, error } = await supabase.from('studentinfoclassdetail').insert(adata).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function updateData(udata) {
    console.log("udata",udata);
    const { data, error } = await supabase.from('studentinfoclassdetail').update(udata).eq('id', udata.id).select();

    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }

  export async function deleteIdData(id) {
    const { data, error } = await supabase.from('studentinfoclassdetail').delete()
    .eq('id', id);
    if (error) {
      throw new Error('Failed to fetch data')
    }

    return data;
  }
